module.exports = __webpack_public_path__ + "img/ch50.e254863f.png";